import { render, staticRenderFns } from "./SelectTags.vue?vue&type=template&id=07f6bffc&"
import script from "./SelectTags.vue?vue&type=script&lang=js&"
export * from "./SelectTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f6bffc')) {
      api.createRecord('07f6bffc', component.options)
    } else {
      api.reload('07f6bffc', component.options)
    }
    module.hot.accept("./SelectTags.vue?vue&type=template&id=07f6bffc&", function () {
      api.rerender('07f6bffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Import/Components/Steps/SelectTags.vue"
export default component.exports